const Box = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3893 0.100051C31.8868 -0.049403 32.4231 0.00225594 32.8829 0.243929L50.9208 9.72391C51.5732 10.0668 51.9817 10.743 51.9817 11.48V39.44C51.9817 40.2876 51.4431 41.0416 50.6413 41.3165L19.8413 51.8765C19.268 52.0731 18.6363 51.9968 18.1263 51.6694L0.928337 40.6294C0.359905 40.2645 0.0162048 39.6354 0.0162048 38.96V11C0.0162048 10.1242 0.590501 9.35202 1.42927 9.10005L31.3893 0.100051ZM3.9838 14.6308L17.2141 23.1239V46.3691L3.9838 37.8761V14.6308ZM21.1817 47.2226L48.0141 38.023V14.2573L21.1817 23.457V47.2226ZM19.4622 19.8522L45.0023 11.0956L31.7545 4.13308L6.69975 11.6595L19.4622 19.8522ZM46.6746 32.5206C47.0277 33.5578 46.4731 34.6848 45.436 35.0379L43.556 35.6779C43.4928 35.6994 43.4292 35.7176 43.3655 35.7325C43.2649 35.7884 43.158 35.8364 43.0454 35.8753L35.0454 38.6353C34.5792 38.7962 34.0939 38.7731 33.6687 38.6047C33.4363 39.0007 33.0662 39.3183 32.5974 39.4779L30.7174 40.1179C29.6803 40.471 28.5532 39.9164 28.2002 38.8792C27.8471 37.8421 28.4016 36.7151 29.4388 36.362L31.3188 35.722C31.783 35.564 32.2651 35.5877 32.6879 35.7552C32.9189 35.3615 33.2861 35.0452 33.7514 34.8846L41.7514 32.1246C41.8172 32.1019 41.8833 32.0829 41.9496 32.0674C42.0525 32.0102 42.1619 31.9613 42.2774 31.922L44.1574 31.282C45.1945 30.9289 46.3216 31.4835 46.6746 32.5206Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Box;
